/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

const ProgressBarWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const ProgressBarBackground = styled.div`
  width: 100%;
  border-radius: 4px;
  height: 32px;
  position: relative;
  overflow: hidden;
`;

const ProgressBarRatio = styled.div`
  border-radius: 4px 0 0 4px;
  position: absolute;
  height: 32px;
  transition: width 1s;
  transition-timing-function: linear;
`;

const ProgressBarLabel = styled.div`
  position: absolute;
  font-family: 'Brandon Text';
  font-style: normal;
  font-weight: 450;
  font-size: 14px;
  line-height: 20px;
  padding: 6px 2px;
  color: #2f9e44;
`;

export {
  ProgressBarWrapper,
  ProgressBarBackground,
  ProgressBarRatio,
  ProgressBarLabel,
};
